/* HL Futter-Check – checks a pasted dog-food ingredient list against the test scope.
   Data: the same JSON as the "Wird das Futter Ihres Hundes getestet?" search (theme setting hl_testumfang).
   HLFutter.analyze(text, data) is pure and runs in Node for tests; mount() binds the UI to [data-hl-fc].
   Wording rule: an ingredient "wird im Test geprüft" – never "verträglich" or "sicher".
   Matching never guesses: a synonym only counts if it is the same food (species/plant, processed form) and its target
   is in the list; anything unknown stays "nicht im Test". No regex lookbehind (older iOS Safari). */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else { root.HLFutter = api; if (root.document) api.mount(root.document); }
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  /* ---------- normalising: hyphens, case, umlauts (also ae/oe/ue), ß/ss ---------- */
  function norm(s) {
    return String(s || '').toLowerCase()
      .replace(/[-‐‑]/g, '')
      .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss')
      .replace(/[éèê]/g, 'e').replace(/[áàâ]/g, 'a')
      .replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u').replace(/ss/g, 's')
      .replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function words(list) { return list.split('|').map(norm).filter(Boolean); }

  /* ---------- synonyms: label words → test-list entries (targets missing from the list are dropped) ----------
     coll = the entry is itself a collective term: named species in brackets replace it ("Geflügel (Gans)") */
  var SYN = [
    // Fleisch
    ['Huhn|Hühner|Hühnchen|Hähnchen|Hahn|Henne|Hennen|Hendl|Hühnerfleisch|Hähnchenfleisch|Hühnchenfleisch|Hühnerbrust|Hähnchenbrust|Chicken|Hühnerfüße|Hühnchenfüße|Hühnerkarkasse|Hühnerkarkassen|Freilandhuhn|Freilandhühner', ['Huhn']],
    ['Hühnermehl|Hähnchenmehl|Hühnerfleischmehl|Hähnchenfleischmehl|Hühnchenmehl', ['Hähnchenmehl', 'Huhn']],
    ['Hühnerfett|Hähnchenfett|Hühneröl', ['Hühnerfett', 'Huhn']],
    ['Hühnerknochen|Hähnchenknochen', ['Hühnerknochen']],
    ['Hühneraroma|Hähnchenaroma|Huhnaroma|Hühnchenaroma', ['Hühneraroma']],
    ['Geflügel|Geflügelfleisch', ['Huhn', 'Putenfleisch', 'Ente'], { group: 1, coll: 1 }],
    ['Pute|Puten|Puter|Truthahn|Truthähne|Putenfleisch|Truthahnfleisch', ['Putenfleisch']],
    ['Ente|Enten|Entenfleisch|Entenfüße', ['Ente']],
    ['Entenei|Enteneier|Enteneiweiß|Enteneigelb', ['Entenei']],
    ['Rind|Rinder|Rindfleisch|Rinderfleisch|Ochse|Ochsen|Kalb|Kälber|Kalbfleisch|Kalbs|Beef|Weiderind|Kuh|Kühe|Kuhfleisch|Ochsenziemer|Rinderziemer|Ochsenschwanz', ['Rindfleisch']],
    ['Rinderleber|Rindleber|Ochsenleber|Kalbsleber', ['Ochsenleber', 'Rindfleisch']],
    ['Rinderknochen|Kalbsknochen|Rindsknochen|Rindknochen|Ochsenknochen', ['Rinderknochen']],
    ['Rinderhaut|Rindshaut', ['Rohhaut', 'Rindfleisch']],
    ['Lamm|Lämmer|Lammfleisch|Schaf|Schaffleisch|Hammel|Hammelfleisch', ['Lammfleisch']],
    ['Lammleber|Schafleber', ['Lammleber', 'Lammfleisch']],
    ['Lammknochen', ['Lammknochen']],
    ['Schwein|Schweine|Schweinefleisch|Schweinsfleisch', ['Schweinefleisch']],
    ['Schweineleber', ['Schweineleber', 'Schweinefleisch']],
    ['Schweineohr|Schweineohren|Schweinsohr|Schweinsohren', ['Schweinsohr']],
    ['Kaninchen|Kaninchenfleisch|Wildkaninchen', ['Kaninchen']],
    ['Hase|Hasen|Feldhase', ['Hase']],
    ['Wild|Wildfleisch', ['Wildfleisch'], { coll: 1 }],
    ['Rohhaut|Kauhaut', ['Rohhaut']],
    // Fisch
    ['Kabeljau|Dorsch', ['Kabeljau']],
    ['Lachs|Wildlachs', ['Lachs']],
    ['Lachsöl', ['Lachs', 'Fischöl']],
    ['Sardine|Sardinen', ['Sardine']],
    ['Krabbe|Krabben', ['Krabbe']],
    ['Meerforelle', ['Forelle (Meer)']],
    ['Fischöl', ['Fischöl'], { coll: 1 }],
    ['Dorschleberöl|Lebertran|Dorschlebertran', ['Dorschleberöl']],
    // Milch & Ei – bare "Eiweiß" also means protein, so it is a Sammelbegriff (see GENERIC)
    ['Ei|Eier|Vollei|Hühnerei|Hühnereier|Eiprodukte|Eiprodukt|Eiererzeugnisse|Eier und Eiererzeugnisse|Volleipulver|Eipulver|Trockenei', ['Eiweiß', 'Eigelb']],
    ['Eiklar|Eiklarpulver|Trockeneiklar|Hühnereiweiß|Hühnereiklar|Hühnereiweißpulver', ['Eiweiß']],
    ['Eigelb|Eidotter|Hühnereigelb|Hühnereidotter', ['Eigelb']],
    ['Milch|Vollmilch|Milchpulver|Magermilch|Magermilchpulver|Molke|Molkenpulver|Molkenprotein|Kuhmilch|Rohmilch|Kasein|Casein|Caseinat|Calciumcaseinat|Kalziumcaseinat|Natriumcaseinat', ['Milch']],
    ['Laktose|Lactose|Milchzucker', ['Laktose']],
    ['Joghurt|Joghurtpulver|Yoghurt', ['Joghurt']],
    ['Hüttenkäse|Körniger Frischkäse|Cottage Cheese', ['Hüttenkäse']],
    ['Cheddar', ['Cheddar-Käse']],
    // Getreide
    ['Weizen|Vollkornweizen|Hartweizen|Weizenmehl|Weizengrieß|Hartweizengrieß|Grieß|Weizenkeime|Weizenkeim|Weizenkeimöl|Weizenfuttermehl|Weizennachmehl|Weizengrießkleie', ['Weizen']],
    ['Weizenkleie', ['Weizen', 'Kleie']],
    ['Weizengluten|Weizenkleber', ['Weizen', 'Gluten']],
    ['Gluten|Kleber', ['Gluten']],
    ['Gerste|Gersten|Gerstenflocken|Gerstenmehl|Gerstenmalz', ['Gerste']],
    ['Hafer|Hafermehl|Haferkleie', ['Gemahlener Hafer', 'Haferflocken']],
    ['Haferflocken', ['Haferflocken']],
    ['Nudeln|Vollkornnudeln', ['Nudeln']],
    ['Weißbrot', ['Weißbrot']],
    ['Mais|Vollkornmais|Maisgrieß|Maisstärke|Maiskleber|Maiskleberfutter|Maisgluten|Mais Gluten|Maisglutenmehl|Maisklebermehl|Maisglutenfutter|Maiskeime|Maisflocken|Maiskleie|Maisgrits|Polenta|Maiskerne', ['Mais']],
    ['Maismehl', ['Maismehl', 'Mais']],
    ['Reis|Bruchreis|Vollkornreis|Naturreis|Langkornreis|Reismehl|Reisprotein|Reisstärke|Reiskleie|Reisflocken', ['Reis']],
    ['Soja|Sojabohnen|Sojabohne|Sojaprotein|Sojaproteinisolat|Sojaschrot|Sojaextraktionsschrot|Sojaöl', ['Sojamehl', 'Sojabohnenmehl']],
    ['Sojasoße', ['Sojasauce']],
    // Gemüse, Obst, Hülsenfrüchte, Nüsse
    ['Karotte|Karotten|Möhre|Möhren|Mohrrübe|Mohrrüben|Gelbe Rübe|Gelbe Rüben', ['Karotten']],
    ['Pastinake|Pastinaken', ['Pastinaken']],
    ['Kartoffel|Kartoffeln|Kartoffelflocken|Kartoffelstärke|Kartoffelprotein|Kartoffeleiweiß|Kartoffelschalen', ['Kartoffel']],
    ['Süßkartoffel|Süßkartoffeln|Süße Kartoffel|Süße Kartoffeln|Batate|Bataten', ['Süßkartoffel']],
    ['Porree|Lauch', ['Porree']],
    ['Zwiebel|Zwiebeln', ['Zwiebel']],
    ['Tomate|Tomaten|Tomatentrester|Tomatenpülpe', ['Tomate']],
    ['Butternut|Butternutkürbis', ['Kürbis (Butternut)']],
    ['Erbse|Erbsen|Erbsenprotein|Erbsenstärke|Erbsenfasern|Erbsenmehl|Erbsenflocken|Zuckererbsen|Zuckerschoten|Markerbsen', ['Erbsen']],
    ['Apfel|Äpfel|Apfeltrester|Apfelpulpe|Apfelpulver', ['Äpfel']],
    ['Banane|Bananen', ['Bananen']],
    ['Zitrone|Zitronen|Zitronenschale|Zitronenschalen', ['Zitronen']],
    ['Orange|Orangen|Orangenschale|Orangenschalen', ['Orangen']],
    ['Himbeere|Himbeeren', ['Himbeeren']],
    ['Erdbeere|Erdbeeren', ['Erdbeeren']],
    ['Hagebutte|Hagebutten|Hagebuttenschale|Hagebuttenschalen', ['Hagebutten']],
    ['Mandel|Mandeln|Mandelkerne', ['Mandeln']],
    ['Erdnuss|Erdnüsse|Erdnusskerne', ['Erdnuss']],
    // Öle, Gewürze, Sonstiges
    ['Kokosöl|Kokosfett|Kokosnussöl', ['Kokosöl']],
    ['Palmfett', ['Palmöl']],
    ['Sonnenblumenkernöl', ['Sonnenblumenöl']],
    ['Pflanzenöl|Pflanzliches Öl|Pflanzliche Öle', ['Pflanzenöl'], { coll: 1 }],
    ['Minze|Pfefferminze|Minzblätter|Pfefferminzblätter', ['Minze']],
    ['Salz|Natriumchlorid|Kochsalz|Meersalz|Speisesalz|Jodsalz|Steinsalz|Himalayasalz|Siedesalz|Viehsalz', ['Salz']],
    ['Rohrzucker|Rübenzucker|Kristallzucker|Saccharose', ['Zucker']],
    ['Hefe|Hefen', ['Hefe'], { coll: 1 }],
    ['Bierhefe|Brauereihefe|Backhefe|Hefeextrakt|Hefezellwände', ['Hefe']],
    ['Agar|Agar-Agar', ['Agar']],
    ['Johannisbrot|Johannisbrotschrot|Johannisbrotmehl|Carob|Carobpulver|Carobmehl', ['Johannisbrot']],
    ['Acidophilus|Lactobacillus acidophilus', ['Acidophilus']],
    // Umwelt & Non-Food, only where they occur in food
    ['Algen|Alge', ['Algen'], { coll: 1 }],
    ['Meeresalgen|Seealgen|Braunalgen|Meeresalge', ['Algen']],
    ['Seetang|Kelp', ['Seetang']],
    ['Löwenzahn|Löwenzahnblätter|Löwenzahnwurzel|Löwenzahnkraut', ['Löwenzahn']],
    ['Brennnessel|Brennnesseln|Brennnesselblätter|Brennnesselkraut|Brennessel', ['Brennnessel']],
    ['Ringelblume|Ringelblumen|Calendula|Ringelblumenblüten', ['Ringelblume']],
    ['Weißdorn|Weißdornblätter|Weißdornblüten|Weißdornbeeren', ['Weißdorn']],
    ['Klee', ['Klee']],
    ['Bienenpollen', ['Bienenpollen']],
    ['Bifidobacterium animalis|Bifidobacterium lactis', ['Bifidobacterium animalis']],
    // Freigegeben von Felix am 2026-10-07 (vorher „ähnlich im Test“)
    ['Kürbis|Hokkaido|Hokkaidokürbis|Muskatkürbis|Kürbiskerne', ['Kürbis (Butternut)']],
    ['Forelle|Regenbogenforelle|Bachforelle|Lachsforelle', ['Forelle (Meer)']],
    ['Hirsch|Reh|Rotwild|Damwild|Hirschfleisch|Rehfleisch|Elch|Rentier', ['Wildfleisch']],
    ['Wildschwein', ['Schweinefleisch']],
    ['Garnele|Garnelen|Shrimps|Nordseekrabben', ['Krabbe']],
    ['Kalmar|Calamari|Sepia|Oktopus|Krake', ['Tintenfisch']],
    ['Dinkel', ['Weizen']],
    ['Kokos|Kokosraspeln|Kokosflocken|Kokosnuss|Kokosmilch|Kokosmehl', ['Kokosöl']],
    ['Bohnen|Grüne Bohnen', ['Gebackene Bohnen']],
    ['Brombeere|Brombeeren|Brombeerblätter', ['Brombeerstrauch']],
    ['Johannisbeere|Johannisbeeren|Schwarze Johannisbeeren', ['Johannisbeerstrauch']],
    ['Birkenblätter', ['Birke']],
    ['Spirulina|Chlorella|Algenöl|Schizochytrium', ['Algen']],
    ['Knotentang|Ascophyllum nodosum|Ascophyllum|Blasentang', ['Seetang']],
    ['Heringsöl|Sardellenöl|Anchovisöl|Seelachsöl', ['Fischöl']],
    ['Rindergelatine|Schweinegelatine|Fischgelatine', ['Gelatine']],
    ['Schafmilch|Schafsmilch|Stutenmilch|Kamelmilch', ['Milch']],
    ['Quark|Magerquark|Topfen', ['Hüttenkäse']],
    ['Gerstengras', ['Gerstenpflanze']],
    ['Palmkernöl', ['Palmöl']],
    ['Wachtelei|Wachteleier|Gänseei|Gänseeier', ['Eiweiß', 'Eigelb']],
    ['Torula|Torulahefe', ['Hefe']]
  ];

  /* close but not the same entry → stays "nicht im Test", with a hint. All former entries were approved as synonyms
     on 2026-10-07 and moved into SYN; add new candidates here first and let Felix decide. */
  var NEAR = [];

  /* collective terms: the label does not say which ingredient exactly → own group, not counted */
  var GENERIC = [
    ['Fleisch|Fleisch und tierische Nebenerzeugnisse|Fleisch und Fleischnebenerzeugnisse|Fleisch und tierische Nebenprodukte|Fleischerzeugnisse|Fleisch und Fleischerzeugnisse|Tierische Nebenerzeugnisse|Tierische Nebenprodukte|Fleischnebenerzeugnisse|Nebenerzeugnisse|Nebenprodukte|Schlachtnebenerzeugnisse|Fleischmehl|Fleischmehle|Tiermehl|Frischfleisch|Muskelfleisch|Innereien|Leber|Herz|Herzen|Lunge|Niere|Nieren|Magen|Pansen|Euter|Knochen|Knorpel|Blut|Blutplasma|Plasma|Hämoglobin|Hämoglobinpulver|Brühe|Fleischbrühe|Fond|Jus|Tierfett|Tierisches Fett|Tierische Fette|Tierisches Protein|Tierische Proteine|Tierprotein|Tierproteine|Hydrolysierte Tierproteine|Tierisches Eiweiß|Tierische Eiweiße|Digest|Geflügelnebenerzeugnisse', 'fleisch'],
    ['Fisch|Fische|Fisch und Fischnebenerzeugnisse|Fischnebenerzeugnisse|Fisch und Fischnebenprodukte|Fischnebenprodukte|Fischmehl|Fischprotein|Seefisch|Seefischmehl|Meeresfisch|Meeresfische|Weißfisch|Weichtiere und Krebstiere|Krebstiere|Weichtiere|Meeresfrüchte', 'fisch'],
    ['Getreide|Getreidenebenerzeugnisse|Getreidenebenprodukte|Getreideerzeugnisse|Getreide und Getreideerzeugnisse|Getreide und Getreidenebenerzeugnisse|Getreidemehl|Vollkorngetreide', 'getreide'],
    ['Gemüse|Gemüsenebenerzeugnisse|Gemüsenebenprodukte|Gemüse und Gemüsenebenerzeugnisse|Gemüsemischung|Gemüsemix|Knollen|Wurzeln', 'gemuse'],
    ['Obst|Früchte|Fruchtnebenerzeugnisse|Früchte und Fruchtnebenerzeugnisse|Obstmischung|Fruchtmischung|Beerenmischung|Waldbeeren', 'obst'],
    ['Milch und Molkereierzeugnisse|Molkereierzeugnisse|Milcherzeugnisse|Milcherzeugnis|Milch und Milcherzeugnisse|Milch und Milchprodukte|Milchprodukte|Käse', 'milch'],
    ['Öle und Fette|Pflanzliche Öle und Fette|Fett|Fette|Öl|Öle', 'ole'],
    ['Kräuter|Kräuter der Provence|Trockenkräuter|Wildkräuter|Kräutermischung|Kräutermix|Gewürze|Kräuter und Gewürze', 'krauter'],
    ['Saaten|Ölsaaten|Ölsaaten und Ölfrüchte|Nüsse', 'nusse'],
    ['Pflanzliche Nebenerzeugnisse|Pflanzliche Nebenprodukte|Nebenerzeugnisse pflanzlichen Ursprungs|Erzeugnisse pflanzlichen Ursprungs|Pflanzliche Erzeugnisse|Pflanzliches Eiweißextrakt|Pflanzliche Eiweißextrakte|Extrakte pflanzlichen Eiweißes|Pflanzliches Protein|Pflanzliche Proteine|Bäckereierzeugnisse|Hülsenfrüchte|Protein|Proteine|Proteinhydrolysat|Hydrolysat|Eiweißhydrolysat|Eiweiß|Eiweiße|Pflanzliches Eiweiß|Pflanzliche Eiweiße|Pflanzeneiweiß|Eiweißpulver|Eiweißkonzentrat|Eiweißextrakt|Ähnliche Erzeugnisse|Füllung', '']
  ];
  var HINTS = {
    fleisch: ['Rindfleisch', 'Huhn', 'Lammfleisch', 'Schweinefleisch', 'Putenfleisch', 'Ente', 'Kaninchen', 'Wildfleisch'],
    fisch: ['Lachs', 'Kabeljau', 'Thunfisch', 'Sardine', 'Schellfisch', 'Krabbe'],
    getreide: ['Weizen', 'Gerste', 'Roggen', 'Haferflocken', 'Mais', 'Reis'],
    gemuse: ['Karotten', 'Erbsen', 'Kartoffel', 'Süßkartoffel', 'Zucchini', 'Tomate'],
    obst: ['Äpfel', 'Bananen', 'Himbeeren', 'Erdbeeren', 'Hagebutten'],
    milch: ['Milch', 'Ziegenmilch', 'Joghurt', 'Hüttenkäse', 'Cheddar-Käse'],
    ole: ['Fischöl', 'Kokosöl', 'Sonnenblumenöl', 'Palmöl', 'Pflanzenöl', 'Hühnerfett'],
    krauter: ['Ingwer', 'Minze'],
    nusse: ['Mandeln', 'Erdnuss']
  };
  /* list entries whose bare name is ambiguous on a label ("Eiweiß" = egg white or protein) */
  var AMBIG = { 'Eiweiß': 1, 'Füllung': 1 };
  /* bark etc. must never reach "Rind" through plural stripping */
  var STOP = 'Rinde|Rinden|Baumrinde|Ulmenrinde|Weidenrinde|Kiefernrinde|Zimtrinde';

  /* words that only describe (processing, origin, husbandry, quality) – dropped before matching */
  var DESCR = {};
  ('frisch frische frisches frischer frischem frischen getrocknet getrocknete getrocknetes getrockneter getrocknetem getrockneten getr ' +
   'gemahlen gemahlene gemahlenes gemahlener gemahlenen gem dehydriert dehydrierte dehydriertes dehydrierter dehydr hydrolysiert hydrolysierte ' +
   'hydrolysiertes hydrolysierter hydrolysierten hydrolisiert hydrolisierte hydrolisiertes hydrolys entbeint entbeinte entbeintes entfettet ' +
   'entfettete entfettetes entf entzuckert entzuckerte entzuckertes entbittert entbitterte entbittertes gekocht gekochte gekochtes gekochter ' +
   'gekochten vorgekocht vorgekochte gebraten gebratene gebratener gebratenes gedämpft gedünstet gegart gegarte vorgegart roh rohe rohes ganz ' +
   'ganze ganzes fein zerkleinert zerkleinerte zerkl püriert blanchiert blanchierte gewolft gewolfte gequetscht gequetschte geschrotet ' +
   'geschrotete geröstet geröstete gekeimt gekeimte mikronisiert mikronisierte gepoppt geflockt geflockte getoastet aufgeschlossen ' +
   'aufgeschlossene aufgeschlossener aufgeschlossenes thermisch entgratet entgratete autolysiert autolysierte luftgetrocknet luftgetrocknete ' +
   'gefriergetrocknet gefriergetrocknete schonend natürlich natürliche natürliches natürlicher bio biologisch biologische biologischem ' +
   'kontrolliert kontrollierter kontrolliertem anbau freiland freilandhaltung weidehaltung bodenhaltung haltung aquakultur wildfang zucht ' +
   'nachhaltig nachhaltiger nachhaltigem fischerei msc asc freilaufend gefangen gefangener gefangene wildgefangen wildgefangener herkunft ' +
   'deutsch deutsches deutscher deutsche deutschem deutschland europa eu regional regionales regionaler irisch irisches irischer irland ' +
   'norwegisch norwegischer norwegische norwegen schottisch schottischer schottland neuseeländisch neuseeländische neuseeländisches ' +
   'neuseeländischen neuseeländischer neuseeland frankreich dänemark polen österreich italien spanien niederlande kanada usa argentinien ' +
   'australien atlantisch atlantischer pazifisch pazifischer kanadisch kaltgepresst kaltgepresste nativ native inaktiviert inaktivierte ' +
   'aschearm extrahiert gentechnikfrei geschält geschälte gehackt geschnitten gewürfelt hochwertig hochwertiges hochwertige konserviert ' +
   'fermentiert gepufft extrudiert gemalzt pasteurisiert pasteurisierte ultrahocherhitzt region teilweise teilw gesamt min mind max ca davon ua inkl entspricht das ein eine einer reich zusammensetzung zutaten')
    .split(' ').forEach(function (w) { DESCR[norm(w)] = 1; });
  /* body parts: inside "Rind (Fleisch, Herz, Leber)" they describe the parent */
  var PARTS = /^(fleisch|muskelfleisch|herz|herzen|leber|lebern|lunge|lungen|niere|nieren|magen|pansen|euter|knochen|knorpel|haut|hals|halse|halsen|flugel|brust|blut|innereien|fett|bruhe|kopf|keule|nebenerzeugnis\w*|schlund|milz|sehnen|bindegewebe|fuse|karkase\w*)$/;
  /* bare species words in brackets after a product ("Milch (Ziege)", "Gelatine (Rind)") name its source */
  var SPECIES = /^(rind|rinder|kalb|ochse|kuh|kuhe|schwein|schweine|lamm|schaf|ziege|ziegen|huhn|huhner|henne|hennen|freilandhuhner|pute|puten|truthahn|ente|enten|gans|ganse|wachtel|wachteln|pferd|biene|bienen|fisch|lachs|kabeljau|dorsch)$/;
  var DAIRY_ITEMS = /^(Milch|Joghurt|Griechischer Joghurt|Laktose|Sahne|Saure Sahne|Geronnene Sahne|Butter|Eiscreme|Hüttenkäse|Cheddar-Käse|Brie|Blauschimmelkäse)$/, EGG_ITEMS = /^(Eiweiß|Eigelb)$/;
  function productKind(items) {
    items = items || [];
    if (items.some(function (i) { return EGG_ITEMS.test(i); })) return 'egg';
    if (items.some(function (i) { return DAIRY_ITEMS.test(i); })) return 'dairy';
    return items.indexOf('Gelatine') > -1 ? 'gel' : '';
  }
  var DAIRY_SRC = /^(rind|rinder|kuh|kuhe|kalb)$/, EGG_SRC = /^(huhn|huhner|huhnern|henne|hennen|freilandhuhn|freilandhuhner|freilandhennen)$/;

  var SUFFIXES = ['fleischmehl', 'fleischbruhe', 'proteinisolat', 'proteinkonzentrat', 'proteinmehl', 'proteinhydrolysat', 'hydrolysat',
    'hackfleisch', 'fleisch', 'protein', 'isolat', 'konzentrat', 'eiweis', 'mehl', 'fett', 'schmalz', 'talg', 'bruhe', 'fond', 'jus', 'leber',
    'lebern', 'herzen', 'herz', 'magen', 'lungen', 'lunge', 'nieren', 'niere', 'pansen', 'euter', 'blut', 'knorpel', 'haut', 'brustfilet',
    'brust', 'filets', 'filet', 'halsen', 'halse', 'hals', 'flugel', 'keulen', 'keule', 'schenkel', 'rucken', 'fuse', 'karkassen', 'karkasse',
    'kehlkopf', 'schlund', 'milz', 'ohren', 'ohr', 'kopfe', 'kopf', 'innereien', 'nebenerzeugnise', 'nebenprodukte', 'gulasch', 'hack',
    'extrakt', 'pulver', 'flocken', 'gries', 'starke', 'fasern', 'faser', 'schrot', 'trester', 'pulpe', 'paste', 'saft', 'schalen', 'schale',
    'wurzeln', 'wurzel', 'sirup', 'mus', 'puree', 'stuckchen', 'stucke', 'streifen', 'ol', 'kleie'];
  var PREFIXES = ['bio', 'freiland', 'weide', 'natur', 'vollkorn', 'bruch', 'trocken', 'frisch', 'mager', 'jung'];
  var SUFFIX_SET = {}; SUFFIXES.forEach(function (s) { SUFFIX_SET[s] = 1; });

  var ADDITIVE = /(^|\s)(e ?\d{1,3}[a-z]?|vit|\d[a-z]\d{2,}\w*|vitamin\w*|provitamin|biotin|fols\w*|niacin\w*|pantothen\w*|cholin\w*|betain|riboflavin|thiamin\w*|pyridoxin\w*|cobalamin|cyanocobalamin|tocopherol\w*|ascorb\w*|menadion\w*|inositol|l ?carnitin|carnitin|taurin|dl ?methionin|methionin|l ?lysin\w*|lysin|threonin|tryptophan|arginin|glucosamin\w*|chondroitin\w*|msm|\w*inulin|\w*oligosaccharid\w*|fos|mos|beta ?d? ?glucan\w*|betad?glucan\w*|nukleotid\w*|mineralstof\w*|mineralien|mineralmischung|spurenelement\w*|calcium\w*|kalzium\w*|kalium\w*|magnesium\w*|natrium ?\w*phosphat|\w*phosphat\w*|eisen|eisen ?ii\w*|kupfer\w*|mangan\w*|zink\w*|jod\w*|iod\w*|selen\w*|kobalt\w*|molybdan\w*|antioxidan\w*|antioxidationsmittel|konservierungs\w*|farbstof\w*|aromastof\w*|bindemittel|geliermittel|verdickungsmittel|emulgator\w*|stabilisator\w*|saurungsmittel|saureregulator\w*|zitronensaure|citronensaure|lecithin\w*|guarkernmehl|johannisbrotkernmehl|casia\w*|carrageen\w*|\w*sorbat|sorbinsaure|propionat\w*|mineralerde|bentonit\w*|zusatzstof\w*|darmflorastabilisator\w*|enterococcus|bacillus|saccharomyces|mono und diglyceride\w*|(?:huhner)?ei(?:er)?schal\w*|austernschal\w*|muschelschal\w*|\w*kalk\w*|lithothamn\w*)(\s|$)|chelat|sulfat|oxid|carbonat|karbonat|selenit|jodat|iodid|hydrat|chlorid/;
  var ADD_ITEM = /^(aminosaur\w*|aroma|aromen|karamel\w*|zuckercouleur|rauch\w*aroma|gelier\w*|verdickungs\w*)$/;
  var ANALYTIC = /^(roh(protein|fett|faser|asche|ol|ole)\w*|feuchtigkeit\w*|feuchte\w*|wasser|trinkwasser|omega\w*( .*)?|energie\w*|umsetzbare energie|kcal|kj|mj|fettgehalt|phosphor|natrium|\w*fettsaur\w*)$/;
  /* head words that only say "a part/extract of …": "Protein der Grünlippmuschel", "Mehl aus Reis" */
  var GENHEAD = /^(kombination|mischung|mix|auswahl|zubereitung|mehl|extrakt|pulver|isolat|konzentrat|hydrolysat|flocken|starke|fasern?|schrot|kleie|saft|mus|puree|granulat|stucke|stuckchen|streifen|filets?|hack|hackfleisch)$/;

  var HEADS = 'zusammensetzung|zutaten|inhaltsstoffe|' +
    'analytische (?:bestandteile|komponenten|inhaltsstoffe)(?:\\s*\\([^)]*\\)|\\s+(?:je|pro|in)\\s+[^:\\n]{1,15})?|' +
    '(?:(?:ernährungsphysiologisch|technologisch|sensorisch|zootechnisch)\\w*\\s+)?(?:zusatzstoffe|zusätze)(?:\\s*\\((?:je|pro)\\s*kg\\)|\\s*(?:je|pro)\\s*(?:kg|kilogramm)(?:\\s*futter)?|\\s*\\/\\s*kg)?|' +
    'spurenelemente(?:\\s*(?:je|pro)\\s*kg|\\s*\\/\\s*kg)?|vitamine(?:\\s*(?:je|pro)\\s*kg|\\s*\\/\\s*kg)?|' +
    'fütterungs\\w*|umsetzbare energie|energie\\w*(?:\\s*(?:je|pro)\\s*100\\s*g)?|nährwert\\w*|gehaltswerte|(?:durchschnittliche\\s+)?analyse|nährstoffe|' +
    'proteinquellen?|kohlenhydratquellen?|zusatzvermerk|hinweise?|allergene|(?:leicht verdauliche\\s+)?einzelfuttermittel|feuchte(?:gehalt)?';
  /* a heading ends with ":" anywhere, or stands alone on its own line */
  var HEAD = new RegExp('(' + HEADS + ')\\s*:|(?:^|\\n)[ \\t•*-]*(' + HEADS + ')[ \\t]*(?=\\r?\\n|$)', 'gi');

  /* ---------- index (built once per data object) ---------- */
  function canon(k) { var c = k.replace(/(en|n|e|s)$/, ''); return c.length >= 4 ? c : ''; }
  function buildIndex(data) {
    var have = {}, exact = {}, lex = {}, can = {}, UNT = { type: 'untested' };
    Object.keys(data || {}).forEach(function (cat) {
      (data[cat] || []).forEach(function (it) {
        have[it] = cat;
        var k = norm(it);
        if (!exact[k] && !AMBIG[it] && cat !== 'Umwelt & Non-Food') exact[k] = { type: 'tested', items: [it] };
      });
    });
    function put(k, e) { if (!lex[k]) lex[k] = e; if (k.indexOf(' ') < 0 && canon(k) && !can[canon(k)]) can[canon(k)] = e; }
    SYN.forEach(function (s) {
      var items = s[1].filter(function (i) { return have[i]; });
      if (!items.length) return;
      var o = s[2] || {};
      words(s[0]).forEach(function (k) { put(k, { type: 'tested', items: items, group: !!o.group, coll: !!o.coll }); });
    });
    // every food entry of the list also matches by its own name (minus "Gemahlenes" etc.), so new list entries work without code
    Object.keys(have).forEach(function (it) {
      if (have[it] === 'Umwelt & Non-Food' || AMBIG[it]) return;
      var k = norm(it), k2 = strip(k);
      put(k, { type: 'tested', items: [it] });
      if (k2 && k2 !== k) put(k2, { type: 'tested', items: [it] });
    });
    NEAR.forEach(function (n) { if (have[n[1]]) words(n[0]).forEach(function (k) { put(k, { type: 'near', hint: n[1] }); }); });
    GENERIC.forEach(function (g) {
      var hint = (HINTS[g[1]] || []).filter(function (i) { return have[i]; });
      words(g[0]).forEach(function (k) {
        var e = { type: 'generic', hint: hint };
        if (!lex[k] || AMBIG_KEY[k]) lex[k] = e;
        if (k.indexOf(' ') < 0 && canon(k) && !can[canon(k)]) can[canon(k)] = e;
      });
    });
    // synonym rows win over the bare list name (they carry coll/group); non-food entries match only through SYN
    Object.keys(exact).forEach(function (k) { if (lex[k]) exact[k] = lex[k]; });
    Object.keys(have).forEach(function (it) { if (have[it] === 'Umwelt & Non-Food') { var k = norm(it); exact[k] = lex[k] || UNT; } });
    words(STOP).forEach(function (k) { exact[k] = UNT; });
    return { have: have, exact: exact, lex: lex, can: can };
  }
  var AMBIG_KEY = {}; Object.keys(AMBIG).forEach(function (a) { AMBIG_KEY[norm(a)] = 1; });
  function strip(k) {
    return k.split(' ').filter(function (w) { return !DESCR[w]; }).join(' ')
      .replace(/(^|\s)(?:der|des|dem|den|vom|von|aus|mit|in|im|zu|und)$/, '').replace(/^(?:der|des|dem|den|vom|von|aus|mit|in|im|zu|und)\s/, '').trim();
  }

  function stem(ix, k, depth) {
    var c = canon(k), e = ix.lex[k] || (c && (ix.can[c] || (c.length >= 5 && ix.lex[c])));
    if (e) return e;
    if (depth > 2) return null;
    for (var i = 0; i < SUFFIXES.length; i++) {
      var s = SUFFIXES[i];
      if (k.length - s.length >= 3 && k.slice(-s.length) === s) { e = stem(ix, k.slice(0, -s.length), depth + 1); if (e) return e; }
    }
    for (i = 0; i < PREFIXES.length; i++) {
      var p = PREFIXES[i];
      if (k.length - p.length >= 3 && k.indexOf(p) === 0) { e = stem(ix, k.slice(p.length), depth + 1); if (e) return e; }
    }
    return null;
  }
  function fin(e) { return e.type === 'near' ? { type: 'untested', hint: e.hint } : e; }
  function okAdj(w) {
    return (/isch(e|er|es|en|em)?$/.test(w) && !/^(tierisch|pflanzlich)/.test(w)) ||
      /^(grun|gelb|rot|weis|schwarz|braun|jung|klein|sus|gros|zart|wild|mild)(e|er|es|en|em)?$/.test(w);
  }
  /* "Ziege" + "Milch" → Ziegenmilch, "Wachteln" + "Eier" → Wachteleier, "Rind" + "Knochen" → Rinderknochen */
  function compound(ix, a, b) {
    a = a.replace(/\s/g, ''); b = b.replace(/\s/g, '');
    var ca = canon(a), cands = [a + b, a + 'n' + b, a + 'en' + b, a + 'er' + b, a + 's' + b];
    if (ca) cands.push(ca + b, ca + 'n' + b);
    var i, e;
    for (i = 0; i < cands.length; i++) { e = ix.exact[cands[i]] || ix.lex[cands[i]]; if (e && (e.type === 'tested' || e.type === 'near')) return fin(e); }
    for (i = 0; i < cands.length; i++) { e = stem(ix, cands[i], 0); if (e && (e.type === 'tested' || e.type === 'near')) return fin(e); }
    return null;
  }
  /* a product (milk, egg, gelatine) from a named species: only the default species counts as the listed entry */
  function viaSource(ix, hs, head, ss) {
    var c = compound(ix, ss, hs);
    if (c) return c;
    var s = ss.split(' ').pop(), kind = productKind(head.items), hint = { type: 'untested', hint: (head.items || []).join(', ') };
    if (kind === 'dairy') return DAIRY_SRC.test(s) ? head : hint;
    if (kind === 'egg') return EGG_SRC.test(s) ? head : hint;
    if (kind === 'gel') return hint;
    return head;
  }

  function classify(ix, raw) {
    var rawN = norm(raw), n = norm(clean(raw).replace(/\s*&\s*/g, ' und '));
    if (!n) return null;
    if (ANALYTIC.test(n) || /^\s*protein\s*[\d.,]+\s*%/i.test(raw)) return { type: 'skip' };
    var e = ix.exact[n] || ix.lex[n];
    if (e) return fin(e);
    var n1 = strip(n);
    if (!n1) return { type: 'skip' };
    e = ix.exact[n1] || ix.lex[n1];
    if (e) return fin(e);
    if (ADDITIVE.test(rawN) || ADD_ITEM.test(n1)) return { type: 'additive' };
    // "Fleischbrühe vom Rind", "Protein der Grünlippmuschel", "Milch von der Ziege", "Eier vom Huhn"
    var m = n1.match(/^(.+?)\s(?:der|des|vom|von der|von dem|von|aus der|aus dem|aus)\s(.+)$/);
    if (m) {
      var hs = m[1], ss = m[2], head = classify(ix, hs), src = classify(ix, ss);
      var c = compound(ix, ss, hs);
      if (c) return c;
      if (GENHEAD.test(hs) || (head && head.type === 'generic')) return src && src.type !== 'skip' ? src : { type: 'untested' };
      if (head && head.type === 'tested') {
        if (!src || src.type === 'skip') return head;
        // "Milch von Büffeln", "Gelatine vom Pferd": a product from an unconfirmed species is not the listed entry
        return (src.type === 'untested' && !src.hint && !productKind(head.items)) ? head : viaSource(ix, hs, head, ss);
      }
      return { type: 'untested' }; // unknown head: don't guess from the source
    }
    var ws = n1.split(' ');
    e = stem(ix, ws.join(''), 0);
    if (!e && ws.length > 1) {
      var last = ws[ws.length - 1], lead = ws.slice(0, -1);
      if (SUFFIX_SET[last]) e = stem(ix, ws.slice(-2).join(''), 0);                                  // "Lachs Öl"
      else if (lead.every(okAdj) && !/^(gluten|kleber)$/.test(last)) e = stem(ix, last, 0);          // "Kanadischer Lachs", "Gelbe Erbsen"
    }
    return e ? fin(e) : { type: 'untested' };
  }

  function sameItems(a, b) { return a.length === b.length && a.every(function (x) { return b.indexOf(x) > -1; }); }
  function subset(a, b) { return a.every(function (x) { return b.indexOf(x) > -1; }); }

  function entry(ix, raw, from) {
    var c = classify(ix, raw);
    if (!c || c.type === 'skip') return null;
    return { name: display(raw), status: c.type, items: c.items || [], group: !!c.group, coll: !!c.coll, hint: c.hint || null, from: from || null };
  }

  /* ---------- text → items ---------- */
  function splitTop(s, extra) {
    var out = [], cur = '', d = 0;
    for (var i = 0; i < s.length; i++) {
      var c = s[i];
      if ('([{'.indexOf(c) > -1) d++;
      else if (')]}'.indexOf(c) > -1) d = Math.max(0, d - 1);
      var sep = false;
      if (d === 0) {
        if (';\n•·|\t▪●◦✓✔'.indexOf(c) > -1) sep = true;
        else if (c === ',') sep = !(/\d$/.test(cur) && /^\d/.test(s.slice(i + 1)));
        else if (c === '.' && /[a-zäöüß]$/i.test(cur) && /^\s+[A-ZÄÖÜ]/.test(s.slice(i + 1)) && !/(\b[a-z]|ca|inkl|min|max|mind|bzw|ggf|vit|dehydr|hydrolys|gem|getr|entf|zerkl)$/i.test(cur)) sep = true;
        else if (extra && extra.test(s.slice(i))) { sep = true; i += s.slice(i).match(extra)[0].length - 1; }
      }
      if (sep) { out.push(cur); cur = ''; } else cur += c;
    }
    out.push(cur);
    return out.map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function brackets(s) {
    var name = '', inner = [], cur = '', d = 0;
    for (var i = 0; i < s.length; i++) {
      var c = s[i];
      if ('([{'.indexOf(c) > -1) { if (d > 0) cur += c; d++; continue; }
      if (')]}'.indexOf(c) > -1) { d = Math.max(0, d - 1); if (d === 0) { inner.push(cur); cur = ''; } else cur += c; continue; }
      if (d > 0) cur += c; else name += c;
    }
    if (cur) inner.push(cur);
    return { name: name, inner: inner };
  }
  /* an opening bracket that never closes would swallow the rest of the list → drop it */
  function balance(t) {
    var open = [], chars = t.split('');
    chars.forEach(function (c, i) { if ('([{'.indexOf(c) > -1) open.push(i); else if (')]}'.indexOf(c) > -1) open.pop(); });
    open.forEach(function (i) { chars[i] = ' '; });
    return chars.join('');
  }
  var NUM = /(^|[^a-zäöüß0-9])(?:(?:ca|min|mind|max)\.?\s*)?\d+(?:[., ]\d{3})*(?:[.,]\d+)?(?:\s*(?:%|prozent\b|mg\b|mcg\b|µg\b|g\b|kg\b|ie\b|i\.\s?e\.))?/gi;
  var LEAD = /^(?:\s*(?:davon|hiervon|darunter|dabei|u\.\s?a|unter anderem|inkl|inklusive|einschlie(?:ß|ss)lich|enthält|bestehend aus|das entspricht|entspricht|vom|von|aus|im häppchen|in der sauce|in der soße|in soße|in sauce|im gelee)\b\.?)+/i;
  function clean(s) {
    s = s.replace(/(vit(?:amin|\.)?\s*)?\b(E)[\s-](\d{1,3}[a-z]?)\b/gi, function (m, v, e, d) { return v ? m : e + d; })
      .replace(NUM, '$1 ').replace(/\s*[,;]\s*([)\]])/g, '$1').replace(/([(\[])\s*[,;]\s*/g, '$1').replace(/[(\[]\s*[)\]]/g, ' ')
      .replace(/\s+/g, ' ').replace(/^[\s,.:;\/&+–—^-]+|[\s,.:;\/&+–—^-]+$/g, '');
    return s.replace(/^[\s=]+/, '').replace(LEAD, '').replace(/^[\s,.:;\/&+=–—-]+/, '').trim();
  }
  function display(s) { s = clean(s); return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }

  var SPLIT = /\s+(?:und|u\.(?!\s?a\b)|oder|sowie|mit)\s+|\s*[&+\/|]\s*/i;
  var TAIL = /(öl|mehl|protein|fett|fleisch|leber|pulver|flocken|stärke|eiweiß|fasern|faser|brühe)$/i;
  function analyzeItem(ix, raw, out) {
    if (/^\s*[-‐]\S/.test(raw)) return;                                   // "Rindfleisch, -herz, -leber": continuation
    if (/^\s*(?:ohne|frei von|kein|keine|keinen)\b/i.test(raw)) return;   // "ohne Getreide"
    var whole = ix.exact[norm(clean(raw))];
    if (whole && whole.type === 'tested' && /[(\[]/.test(raw)) { out.push(entry(ix, raw)); return; }
    var b = brackets(raw), nm = b.name.trim();
    if (!clean(nm)) { b.inner.forEach(function (x) { if (!/quelle|omega/i.test(x)) analyzeItem(ix, x, out); }); return; }
    // "Joghurt mit lebenden Kulturen", "Huhn mit Haut": the rest only describes
    var mm = nm.match(/^(.+?)\s+mit\s+(.+)$/i);
    if (mm && (PARTS.test(norm(mm[2])) || /^(lebenden? )?kulturen$|^(haut|schalen?|fell|knochen)$/.test(norm(mm[2])))) nm = mm[1];
    // "Huhn und Reis", "Lamm mit Reis", "Huhn/Pute", "Fisch- und Lachsöl"; EU terms like "Öle und Fette" stay whole
    var nn = norm(clean(nm).replace(/\s*&\s*/g, ' und '));
    if (SPLIT.test(nm) && !(ix.exact[nn] || ix.lex[nn] || ix.lex[strip(nn)] || ADDITIVE.test(nn))) {
      var parts = nm.split(SPLIT).filter(function (p) { return clean(p); });
      if (parts.length > 1) {
        var tail = (parts[parts.length - 1].match(TAIL) || [''])[0];
        parts.forEach(function (p, i) {
          if (/-\s*$/.test(p) && tail) p = p.replace(/-\s*$/, '') + tail;
          analyzeItem(ix, p + (i === parts.length - 1 ? b.inner.map(function (x) { return ' (' + x + ')'; }).join('') : ''), out);
        });
        return;
      }
    }
    var parent = entry(ix, nm);
    if (!parent) return;
    if (parent.status === 'additive') { out.push(parent); return; }
    var pn = strip(norm(clean(nm))), phead = pn.split(' ')[0] || '';

    var kids = [], partial = false, marker = false;
    b.inner.forEach(function (inner) {
      if (/quelle/i.test(inner)) return;
      if (/\b(davon|hiervon|darunter|u\.\s?a\b|unter anderem|inkl|mit)\b/i.test(inner)) partial = marker = true;
      var txt = inner.replace(/\bin (?:den|der|dem)\s[^,;]*?(?:krok|stück|stueck|brocken|pellets|häppchen)\w*/gi, ' ');
      splitTop(txt, /^\s+und\s+/i).forEach(function (p) {
        var pk = norm(clean(p));
        if (/^\s*[-‐]\S/.test(p) || PARTS.test(pk)) return;
        // "Milch (Ziege)", "Gelatine (Rind)", "Knochenmehl (Rind)": the species is the source, not a second ingredient
        var kp = strip(pk), kc = kp && productKind(parent.items) ? classify(ix, kp) : null;
        if (kp && parent.status === 'tested' && !parent.coll && (SPECIES.test(kp) || (kc && (kc.type === 'untested' && !kc.hint || kc.type === 'tested' && !productKind(kc.items))))) {
          var v = viaSource(ix, pn, { type: 'tested', items: parent.items }, kp);
          parent.status = v.type; parent.items = v.items || []; parent.hint = v.hint || null;
          return;
        }
        var tmp = [];
        analyzeItem(ix, p, tmp);
        tmp.forEach(function (k) { if (k.name) { k.from = k.from || parent.name; kids.push(k); } });
        if (tmp.length && /\d\s*%/.test(p)) partial = true;
      });
    });
    function dedupe(list) {
      return list.filter(function (k, i) {
        return !list.slice(0, i).some(function (o) { return (o.status === 'tested' && k.status === 'tested' && subset(k.items, o.items)) || norm(o.name) === norm(k.name); });
      });
    }
    var named = dedupe(kids.filter(function (k) { return k.status === 'tested' || k.status === 'untested'; }));
    if (parent.status === 'generic') {
      if (!named.length || partial) out.push(parent);
      named.forEach(function (k) { out.push(k); });
      return;
    }
    if (parent.coll && parent.status === 'tested') {
      // "Pflanzenöl (Kokos)" → Kokosöl, "Fischöl (Lachs)" → Lachsöl
      if (/ol$/.test(pn)) named = named.map(function (k) {
        var o = classify(ix, clean(k.name) + 'öl');
        return o && o.type === 'tested' ? { name: parent.name + ' (' + k.name + ')', status: 'tested', items: o.items, group: false, coll: false, hint: null, from: null } : k;
      });
      // kids that only repeat the parent ("Geflügel (Geflügelfleisch, Geflügelhälsen)") – kept only if other kids replace the parent
      var rest = named.filter(function (k) { return !(k.status === 'tested' && sameItems(k.items, parent.items)) && !(k.status === 'untested' && phead.length >= 3 && norm(k.name).indexOf(phead) === 0 && (SUFFIX_SET[norm(k.name).slice(phead.length)] || PARTS.test(norm(k.name).slice(phead.length)))); });
      if (rest.length) named = named.filter(function (k) { return rest.indexOf(k) > -1 || k.status === 'tested'; });   // "Wild (Hirsch, Wildschwein)" keeps Hirsch
      else named = [];
      if (named.length) {
        // the brackets say which species/plant: they replace the collective term ("Geflügel (Gans)", "Wild (Hirsch)");
        // only "davon/u. a." leaves room for more – a bare percentage does not ("Geflügel (Gans 100%)")
        if (marker) out.push(parent);
        named.forEach(function (k) { out.push(k); });
        return;
      }
    }
    out.push(parent);
    var seen = [parent.items];
    kids.forEach(function (k) {
      if (k.status === 'untested') { if (marker && named.indexOf(k) > -1) out.push(k); return; } // "Huhn (mit 10% Hirse)"
      if (k.status !== 'tested') return;
      var dup = seen.some(function (s) { return parent.group && s === parent.items ? sameItems(k.items, s) : subset(k.items, s); });
      if (!dup) { seen.push(k.items); out.push(k); }
    });
  }

  function segments(text) {
    var t = String(text || '').replace(/\r/g, '');
    var marks = [], m;
    HEAD.lastIndex = 0;
    while ((m = HEAD.exec(t))) marks.push({ at: m.index, end: m.index + m[0].length, h: (m[1] || m[2]).toLowerCase() });
    if (!marks.length) return [{ kind: 'comp', text: t }];
    var segs = [], hasComp = marks.some(function (x) { return /^(zusammensetzung|zutaten)/.test(x.h); });
    if (!hasComp && marks[0].at > 0) segs.push({ kind: 'comp', text: t.slice(0, marks[0].at) });
    marks.forEach(function (x, i) {
      var body = t.slice(x.end, i + 1 < marks.length ? marks[i + 1].at : t.length), kind;
      if (/^(zusammensetzung|zutaten)/.test(x.h)) kind = 'comp';
      else if (/^inhaltsstoffe/.test(x.h)) {
        // shops sometimes put composition and analysis under one heading
        var a = body.search(/\b(?:roh(?:protein|fett|faser|asche)|protein\s+\d|fett\s+\d)/i);
        if (a === -1) kind = 'comp';
        else { if (body.slice(0, a).trim()) segs.push({ kind: 'comp', text: body.slice(0, a) }); return; }
      }
      else if (/zusatzstoffe|zusätze|zusatze|spurenelemente|vitamine/.test(x.h)) kind = 'add';
      else if (/quelle/.test(x.h)) kind = 'src';
      else kind = 'skip';
      segs.push({ kind: kind, text: body });
    });
    return segs;
  }
  function stripNotes(t) {
    return t
      .replace(/^\s*(?:[IVX]{1,4}|\d)?\s*das produkt enthält.*$/gim, ' ')
      .replace(/\(\s*\*[^)]*\)/g, ' ')                                   // "(*getrocknet, **kaltgepresst)"
      .replace(/^\s*\*.*$/gm, ' ')                                       // "* getrocknet" / "*) getrocknet" lines
      .replace(/\.\s*\*[^\n]*$/gm, '.')                                  // "… Kräuter. *85% natürlich."
      .replace(/(\s\*+[¹²³⁴⁵⁶\d]*\)?\s*[a-zäöüß][^,;*\n]*)+\s*$/i, ' ') // "Yucca *¹getrocknet *²entzuckert"
      .replace(/[*¹²³⁴⁵⁶⁷⁸⁹⁰†]+/g, '')                                   // markers; never the ")" after them
      .replace(/([a-zäöüß]{3,})([1-9])(?=\)?(?:[\s,;.(\/]|$))/gi, function (m, w) { return /omega$/i.test(w) ? m : w; }); // "Rind1" (copied <sup>)
  }
  /* composition text: first list paragraph, bullets, line wraps, flavour headers, notes that are not ingredients */
  function prepComp(t) {
    var paras = t.replace(/^\s+/, '').split(/\n[ \t]*\n/).filter(function (p) { return p.trim(); });
    var multi = false;
    function listLike(p) {
      if (/\b(wir|unser\w*|sie|bitte|ist|sind|geeignet|empfohlen|empfehlen|füttern|fütterung|hinweis|allergi\w*)\b/i.test(p)) return false;
      var seg = p.split(/[,;\n]/).filter(function (x) { return x.trim(); });
      return seg.length > 1 && p.replace(/\s+/g, ' ').length / seg.length < 60;
    }
    var start = 0;
    for (var pi = 0; pi < paras.length; pi++) if (/[,;]/.test(paras[pi])) { start = pi; break; }
    var take = [paras[start] || ''];
    for (pi = start + 1; pi < paras.length && listLike(paras[pi]); pi++) take.push(paras[pi]);   // "Huhn, Reis\n\nHirse, Leinsamen"
    t = take.join('\n');
    t = t.replace(/^[ \t]*(?:[-–—‐•·▪●◦✓✔]|\d{1,2}[.)])[ \t]+/gm, '');
    t = t.replace(/([a-zäöüß])-[ \t]*\n[ \t]*(?=[a-zäöüß])/g, '$1')
      .replace(/(^|[\s(])(und|oder|sowie|mit|aus|von|vom|der|des|tierische[nrs]?|pflanzliche[nrs]?)[ \t]*\n[ \t]*/gi, '$1$2 ')
      .replace(/([a-zäöüß])[ \t]*\n[ \t]*(?=(?:und|oder|sowie|aus|von|vom|der|des|getrocknet\w*|hydrolysiert\w*|gemahlen\w*|entfettet\w*|dehydriert\w*)\b)/g, '$1 ');
    var lines = t.split('\n'), keep = [];
    for (var i = 0; i < lines.length; i++) {
      var l = lines[i];
      if (/^[^,;()\d]{2,80}:\s*$/.test(l)) {                     // "Huhn:" – a flavour header
        if (keep.join('').trim()) { multi = true; break; }       // a second flavour starts → keep the first only
        continue;
      }
      if (!keep.join('').trim() && /^\s*mit\s[^,]*$/i.test(l)) continue;     // "mit Lamm und Gemüse" above the list
      if (/^\s*[\d¹²³⁴⁵⁶*]+\)?\s+\D+$/.test(l) && !strip(norm(l.replace(/^\s*[\d¹²³⁴⁵⁶*]+\)?/, '')))) continue; // "1 getrocknet"
      if (keep.join('').trim() && /\b(allergi\w*|unverträglich\w*|verträgt|geeignet|empfohlen|ideal für)\b/i.test(l)) continue;
      keep.push(l);
    }
    t = keep.join('\n');
    var hm = t.search(/\n[ \t]*[A-ZÄÖÜ][a-zäöüß]+(?:[ \t]+[A-Za-zäöüß]+){0,3}[ \t]*:(?![ \t]*\d)/);  // "Hinweis:", "Weitere Sorten:"
    if (hm > -1) t = t.slice(0, hm);
    return { text: balance(t), multi: multi };
  }

  var cache = { data: null, ix: null };
  function analyze(text, data) {
    if (cache.data !== data) cache = { data: data, ix: buildIndex(data) };
    var ix = cache.ix, out = [], adds = [], multi = false;
    segments(text).forEach(function (seg) {
      if (seg.kind === 'skip') return;
      var t = stripNotes(seg.text);
      if (seg.kind === 'add') {
        t = t.replace(/^\s+/, '').split(/\n[ \t]*\n/)[0];
        var hm = t.search(/\n[ \t]*[A-ZÄÖÜ][\wäöüß .-]{2,40}:(?![ \t]*\d)/);
        if (hm > -1) t = t.slice(0, hm);
        t = t.replace(/\b(?:\d[a-z]\d+\w*|e\d{3}[a-z]?)\s*\/\s*/gi, '').replace(/\b\d[a-z]\d{2,}[a-z]?(?:\([a-z]+\))?/gi, '').replace(/\s+-\s+/g, ', ');
        splitTop(balance(t)).forEach(function (raw) {
          var nm = display(brackets(raw).name.replace(/^\s*(?:mg|ie|µg|mcg)\s*\/\s*kg\s*:\s*/i, '').replace(/\s*:?\s*\/\s*kg\b/gi, ''));
          if (nm && !/^(je|pro)\s*kg$/i.test(nm) && !/^(wasserfrei|monohydrat|dihydrat|pentahydrat|heptahydrat|fest)$/i.test(nm)) adds.push(nm);
        });
        return;
      }
      var pc = prepComp(t);
      if (pc.multi) multi = true;
      var target = seg.kind === 'src' ? [] : out;
      splitTop(pc.text).forEach(function (raw) {
        var before = target.length;
        analyzeItem(ix, raw, target);
        for (var i = before; i < target.length; i++) if (target[i].status === 'additive') adds.push(target[i].name);
      });
      // "Proteinquelle: …" usually repeats the list – add only what is new
      if (seg.kind === 'src') target.forEach(function (e) {
        var k = strip(norm(e.name)), kc = canon(k) || k;
        var dup = out.some(function (o) { var ok = strip(norm(o.name)); return (canon(ok) || ok) === kc || (e.status === 'tested' && o.status === 'tested' && subset(e.items, o.items)); });
        if (!dup) out.push(e);
      });
    });
    var seenAdd = {};
    adds = adds.filter(function (a) { var k = norm(a); if (!k || seenAdd[k]) return false; seenAdd[k] = 1; return true; });
    var seenName = {};
    var list = out.filter(function (e) {
      if (e.status === 'additive' || !e.name) return false;
      var k = e.status + ':' + norm(e.name);
      if (seenName[k]) return false; // "Hefe*, … Hefe* (extrahiert)" → once
      seenName[k] = 1; return true;
    });
    var tested = list.filter(function (e) { return e.status === 'tested'; });
    var untested = list.filter(function (e) { return e.status === 'untested'; });
    var generic = list.filter(function (e) { return e.status === 'generic'; });
    return { tested: tested, untested: untested, generic: generic, additives: adds, counted: tested.length + untested.length, multi: multi };
  }

  /* ---------- UI ---------- */
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function same(a, b) { var x = strip(norm(a)), y = strip(norm(b)); return x === y || (canon(x) || x) === (canon(y) || y); }
  function chip(e) {
    var sub = [];
    if (e.status === 'tested' && e.items.length && !(e.items.length === 1 && same(e.name, e.items[0]))) {
      sub.push(e.group ? 'im Test: ' + e.items.join(', ') + ' – andere Geflügelarten nicht' : 'geprüft als ' + e.items.join(', '));
    }
    if (e.hint && e.status === 'untested') sub.push('ähnlich im Test: ' + e.hint);
    if (e.status === 'generic') sub.push(e.hint && e.hint.length ? 'im Test u. a. ' + e.hint.slice(0, 6).join(', ') : 'Herkunft nicht genannt');
    if (e.from) sub.push('aus „' + e.from + '“');
    return '<li class="hl-fc__chip"><span>' + esc(e.name) + '</span>' + (sub.length ? '<small>' + esc(sub.join(' · ')) + '</small>' : '') + '</li>';
  }
  function render(r) {
    if (!r.counted && !r.generic.length) {
      return '<p class="hl-fc__empty">Wir konnten darin keine Zutatenliste erkennen. Kopieren Sie den Text hinter „Zusammensetzung“ von der Packung oder aus dem Shop.</p>';
    }
    var x = r.tested.length, y = r.counted, g = r.generic.length, h = '';
    h += '<div class="hl-fc__score">';
    if (y) {
      // green = geprüft, orange = Sammelbegriffe, grey = nicht im Test
      h += '<div class="hl-fc__ring" style="--p:' + Math.round(x / (y + g) * 100) + ';--q:' + Math.round((x + g) / (y + g) * 100) + '" aria-hidden="true"><b>' + x + '</b><span>von ' + y + '</span></div>';
    }
    h += '<div class="hl-fc__score-txt"><p class="hl-fc__headline">' + (y
      ? '<b>' + x + ' von ' + y + '</b> ' + (g ? 'genau benannten ' : '') + (y === 1 ? 'Zutat wird' : 'Zutaten werden') + ' im Unverträglichkeitstest geprüft.'
      : 'Das Etikett nennt keine Zutat genau.') + '</p>';
    if (g) h += '<p class="hl-fc__sub">Dazu ' + (g === 1 ? 'kommt 1 Sammelbegriff' : 'kommen ' + g + ' Sammelbegriffe') + ' – welche Zutaten genau dahinterstecken, steht nicht auf dem Etikett.</p>';
    if (r.additives.length) h += '<p class="hl-fc__sub">Nicht mitgezählt: ' + r.additives.length + (r.additives.length === 1 ? ' Angabe' : ' Angaben') + ' zu Zusatzstoffen, Vitaminen und Mineralstoffen.</p>';
    if (r.multi) h += '<p class="hl-fc__sub hl-fc__sub--warn">Der Text enthielt mehrere Sorten – geprüft haben wir nur die erste. Für eine andere Sorte bitte nur deren Zusammensetzung einfügen.</p>';
    h += '</div></div>';
    function group(cls, title, list, text) {
      if (!list.length) return '';
      return '<section class="hl-fcg hl-fcg--' + cls + '"><h3>' + title + ' <em>' + list.length + '</em></h3>' + (text ? '<p>' + text + '</p>' : '') + '<ul>' + list.map(chip).join('') + '</ul></section>';
    }
    h += '<div class="hl-fc__groups">';
    h += group('ok', 'Wird im Test geprüft', r.tested, '');
    h += group('no', 'Nicht im Test enthalten', r.untested, 'Diese Zutaten stehen nicht auf unserer Testliste – oder wir konnten sie nicht eindeutig zuordnen, z. B. bei Tippfehlern.');
    h += group('gen', 'Sammelbegriffe – nicht genau benannt', r.generic, 'Hier nennt das Etikett nicht, welche Zutat genau enthalten ist.');
    if (r.additives.length) {
      h += '<details class="hl-fcg hl-fcg--add"><summary><h3>Zusatzstoffe, Vitamine & Mineralstoffe – nicht Teil des Tests <em>' + r.additives.length + '</em></h3></summary>' +
        '<p>' + esc(r.additives.join(' · ')) + '</p></details>';
    }
    h += '</div>';
    return h;
  }

  function mount(doc) {
    function init() {
      Array.prototype.forEach.call(doc.querySelectorAll('[data-hl-fc]'), function (root) {
        if (root.__hlfc) return; root.__hlfc = 1;
        var data;
        try { data = JSON.parse(root.querySelector('[data-hl-fc-data]').textContent); } catch (e) { data = null; }
        if (!data || !Object.keys(data).length) {   // no list → no verdicts at all (would show everything as "nicht im Test")
          var o = root.querySelector('[data-hl-fc-result]');
          if (o) { o.hidden = false; o.innerHTML = '<p class="hl-fc__empty">Die Testliste konnte gerade nicht geladen werden. Bitte laden Sie die Seite neu.</p>'; }
          var bt = root.querySelector('form button[type="submit"]'); if (bt) bt.disabled = true;
          return;
        }
        var form = root.querySelector('form'), ta = root.querySelector('textarea'), out = root.querySelector('[data-hl-fc-result]');
        var sample = root.querySelector('[data-hl-fc-sample]'), clear = root.querySelector('[data-hl-fc-clear]'), timer;
        function run(scroll) {
          var v = ta.value.trim();
          if (v.length < 3) { out.hidden = true; out.innerHTML = ''; root.classList.remove('has-result'); return; }
          out.innerHTML = render(analyze(v, data));
          out.hidden = false; root.classList.add('has-result');
          if (scroll && out.getBoundingClientRect().top > window.innerHeight * 0.7) out.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        form.addEventListener('submit', function (e) { e.preventDefault(); run(true); });
        ta.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { run(false); }, 350); });
        if (sample) sample.addEventListener('click', function () { ta.value = sample.getAttribute('data-text'); run(true); });
        if (clear) clear.addEventListener('click', function () { ta.value = ''; run(false); ta.focus(); });
        if (ta.value.trim()) run(false);
      });
    }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
    doc.addEventListener('shopify:section:load', init);
  }

  return { analyze: analyze, render: render, mount: mount, norm: norm };
}));
